import { noSummitCards } from '@lc/const/modifiers';
import { decisionSummitDraft } from '@lc/const/turnTypes';
import { GameState } from '@lc/interface/gameState/types';

import { setStateForPRTurnDecision } from './gamestate_helper';
import { getPlayerStateWithId } from './player_helper';

/*
    4 summit cards

    let arr = [
        [p0, p1, p2],
        []
    ]

    let arr = [
        [p0, p1],
        [p2]
    ]

    let arr = [
        [p0],
        [p1],
        [p2],
    ]

    given 1 2 or 3 players (aka, num players in the current tier of summit draft player ids)
    for each player at given tier, dole out a fair number of cards for them to chose from, from the remaining number of summit cards left to pick
*/

// if my summit turn && available in my summit card choices
// remove card from summitDraftCardIds
// set the next summit player so they can take their turn next

// I CHOOSE MY CARD.
// IF NO MORE PLAYERS TO PICK CARD, RETURN TRUE

const summitConsoleTesting = false;

function logSummitDraftStateVars(
	gameState: GameState,
	enterFunction: string = ''
) {
	if (!summitConsoleTesting) {
		return;
	}
	console.log('logSummitDraftStateVars' + ' ' + enterFunction);
	/** Players in Summit **/
	console.log('activePlayerId: ' + gameState.activePlayerId);
	// 2d array, playerIds sorted among "levels" of donation.
	// Example(4 player game): [[1,2],[0]], player 3 pop()'d
	// Example(3 player game): [[1,2]], player 2 pop()'d
	console.log(
		`summitDraftPlayerIds: ${JSON.stringify(gameState.summitDraftPlayerIds)}`
	);

	/** Cards in Summit **/
	// all cards up for grabs this summit draft. summitDraftCardIds.length == numPlayers
	console.log(
		`summitDraftCardIds: ${JSON.stringify(gameState.summitDraftCardIds)}`
	);

	// 2d fair distribution of current "level"
	// i.e. 2 players contribute same amount, they each get equal choice
	// Example(4 player game): p1 choice = [1,12], p2 choice = [3,6]. End Result: [[1,12],[3,6]]
	console.log(
		`summitDraftCardIdArrForDepth: ${JSON.stringify(gameState.summitDraftCardIdArrForDepth)}`
	);

	// current player's slice of the pie (fair distribution)
	// If activePlayerId = p1.player_id from summitDraftCardIdArrForDepth -> summitDraftCardIdForPlayer = [1,12]
	console.log(
		`summitDraftCardIdForPlayer: ${JSON.stringify(gameState.summitDraftCardIdForPlayer)}`
	);
}

/**
 * Make sure you display the socket's card choice in console logs, along with who picked it.
 * good thing is you're at a cool testing location
 * @param playerData
 * @param gameState
 * @param ticker
 * @returns
 */
export async function chooseSummitCard(
	playerData: any,
	gameState: GameState,
	ticker: string[]
) {
	const { playerId, cardId } = playerData;
	const pState = getPlayerStateWithId(gameState.playerStateArray, playerId);
	let isDraftComplete = false;

	console.log('chooseSummitCard summit_helper');
	logSummitDraftStateVars(gameState, 'chooseSummitCard');

	if (gameState.summitDraftCardIds.includes(cardId)) {
		gameState.summitDraftCardIds.splice(
			gameState.summitDraftCardIds.indexOf(cardId),
			1
		);

		if (!pState.modifiers.includes(noSummitCards)) {
			pState.summitCards.push(cardId);
		}

		// ticker.unshift(`Player: ${playerId} has chosen a summit card with id: ${cardId}`);
		const nextActivePlayerId = getDeepestFirstElement(
			gameState.summitDraftPlayerIds
		);
		if (typeof nextActivePlayerId === 'number' && nextActivePlayerId >= 0) {
			if (gameState.summitDraftCardIdArrForDepth.length === 0) {
				await createSummitCardChoicesForContributionTier(gameState);
			}
			gameState.summitDraftCardIdForPlayer =
				gameState.summitDraftCardIdArrForDepth.shift() || [];
			isDraftComplete = await setNextActiveSummitPlayer(gameState);
		} else {
			isDraftComplete = true;
		}
	}
	// goto a socket emit for next player to determine their summit card. TODO add AI random selection of cards
	return isDraftComplete;
}

// create an array of card choices per player at given tier
async function createSummitCardChoicesForContributionTier(
	gameState: GameState
) {
	console.log('createSummitCardChoicesForContributionTier');
	gameState.summitDraftCardIdArrForDepth = [];
	const contributionPlayerIdCurrentTier = gameState.summitDraftPlayerIds[0];

	if (contributionPlayerIdCurrentTier.length === 0) {
		console.log('All players contributed same amount. Skipping Summit.');
		return;
	}

	const numCardsPerPlayerChoice = Math.floor(
		gameState.summitDraftCardIds.length /
			contributionPlayerIdCurrentTier.length
	);

	let sIndex = 0;

	for (let i = 0; i < contributionPlayerIdCurrentTier.length; i++) {
		const summitCardChoices: any[] = [];
		for (let j = 0; j < numCardsPerPlayerChoice; j++) {
			summitCardChoices.push(gameState.summitDraftCardIds[sIndex]);
			sIndex++;
		}
		gameState.summitDraftCardIdArrForDepth.push(summitCardChoices);
	}

	gameState.summitDraftCardIdForPlayer =
		gameState.summitDraftCardIdArrForDepth.shift() || [];

	console.log('gameState.summitDraftCardIdForPlayer');
	console.log(gameState.summitDraftCardIdForPlayer);
}

// creates 2d array of highest to least contributions
// Per person in row, mod remaining # of summit cards
// send for client decision
async function getSummitDraftOrder(gameState: GameState) {
	const playersContributionArr: any[] = [];

	for (const player of gameState.playerStateArray) {
		playersContributionArr.push({
			playerId: player.playerId,
			contribution: player.donationCupArr.length,
		});
	}

	const summitDraftOrder: number[][] = [];
	let getHighestContributers = true;
	while (playersContributionArr.length > 0) {
		let maxContribution = 0;
		for (let i = 0; i < playersContributionArr.length; i++) {
			if (playersContributionArr[i].contribution > maxContribution) {
				maxContribution = playersContributionArr[i].contribution;
			}
		}

		const currHighestContributionIds: number[] = [];
		for (let z = playersContributionArr.length - 1; z >= 0; z--) {
			if (playersContributionArr[z].contribution === maxContribution) {
				const tempP = playersContributionArr.splice(z, 1);
				currHighestContributionIds.push(tempP[0].playerId);
			}
		}

		if (getHighestContributers) {
			gameState.summitWinners.push([...currHighestContributionIds]);
			getHighestContributers = false;
		}
		summitDraftOrder.push([...currHighestContributionIds]);
	}

	summitDraftOrder.pop(); // drop lowest contributor. Can't be all players
	gameState.summitDraftPlayerIds = summitDraftOrder;
	console.log('summitDraftOrder', summitDraftOrder);
	console.log('summitDraftOrder is 1d', isOneDimensional(summitDraftOrder));
}

// Function to check if an array is strictly 1D
function isOneDimensional(arr: any) {
	if (!Array.isArray(arr)) {
		return false; // Not an array at all
	}
	// Check if every element in the array is not an array
	return arr.every((entry) => !Array.isArray(entry));
}

// I hate how this works, so we're going to do this instead.
// create a simple 2d array of player id's and numPlayersAtDepth
// if id's in the summitDraftOrder + id's of the array you're going to add for turn order add up
// to numPlayers in game, don't add id's
export async function prepSummitDraft(gameState: GameState, ticker: string[]) {
	// align color, playerId and donation amount
	logSummitDraftStateVars(gameState, 'prepSummitDraft');
	await getSummitDraftOrder(gameState);
	logSummitDraftStateVars(gameState, 'getSummitDraftOrder');

	if (gameState.summitDraftPlayerIds.length > 0) {
		gameState.summitDraftCardIds = gameState.DeckSummit.splice(
			0,
			gameState.numPlayers
		);

		await createSummitCardChoicesForContributionTier(gameState);
		logSummitDraftStateVars(
			gameState,
			'createSummitCardChoicesForContributionTier'
		);
		await setNextActiveSummitPlayer(gameState);
		logSummitDraftStateVars(gameState, 'setNextActiveSummitPlayer');
		gameState.turnType = decisionSummitDraft;
	} else {
		await setStateForPRTurnDecision(gameState, ticker);
		logSummitDraftStateVars(gameState, 'setStateForPRTurnDecision');
	}

	// logSummitDraftStateVars(gameState, 'prepSummitDraft');
}

function getDeepestFirstElement(arr: any) {
	// Check if the input is an array and not null
	if (Array.isArray(arr)) {
		// If the array is empty, return undefined
		if (arr.length === 0) {
			return undefined;
		}
		// Get the first element
		const firstElement = arr[0];
		// If the first element is also an array, recurse
		if (Array.isArray(firstElement)) {
			return getDeepestFirstElement(firstElement);
		} else {
			// Otherwise, return the first element
			return firstElement;
		}
	}
	// If the input is not an array (e.g., if it's already the desired value), return it
	return arr;
}

// sets acitvePlayerId to next person in draft order
// returns isDraftComplete, aka no playerIds left in summitDraft
async function setNextActiveSummitPlayer(gameState: GameState) {
	console.log(
		'gameState.summitDraftPlayerIds',
		gameState.summitDraftPlayerIds
	);
	gameState.activePlayerId = gameState.summitDraftPlayerIds[0][0];
	console.log('setNextActiveSummitPlayer', gameState.activePlayerId);

	if (gameState.activePlayerId == null) {
		console.log('This shouldnt happen but activePlayerId wasnt set');
		gameState.activePlayerId = 0;
	}

	if (gameState.summitDraftPlayerIds[0].length >= 1) {
		gameState.summitDraftPlayerIds[0].shift();
	} else if (gameState.summitDraftPlayerIds.length >= 1) {
		gameState.summitDraftPlayerIds.shift();
	} else {
		console.log('i think were ending the draft early');
		return true;
	}
	return false;
}

/*
    so, i need to figure out my "next" summit donation
    List of id's that have contributed the max amount
    then store remaining id's in...
    could be a 3D array, push id's into whomever donated the most, the next most, the next most, and last

    we can go through each step of the arrays given the summit cards, and have a tracker

    we can have a parallel set of summit card ids to follow down the draft

    4 way tie, nobodya wins
    3 players in top tier, each gets one randomly, 4th gets nothing
    2 top, 1 lower, 1 lowest: 2 top each get choice of 2. 3rd player gets choice of their leftovers. final gets nothing

    so

    4 summit cards, don't need the same tier array

    players will always be sorted into a 4x4 array
    players will have a pool of 4 summit cards to decide upon
    we will decend down the 3d part of the array
    if num players in row doesn't exceed total numPlayers, keep doling out cards
    each player gets a mod num players in row of summit cards to look at
    selected card is removed from summitDraftIdArr

    eventually AI will need to resolve decision
*/

// always look at current draft tier, also have index of which player I'm dealing with
// give player choice of array of pickable summit cards given index

// good youtube short idea
// What to name a varaible?
// This guy needs to be a decision creator event for my clients
// with 1 client selected as the person whom i expect the response from
// so I can't use turnorder, or since I can have a dynamic thing, I can just set whos turn it is for this choice

// given activePlayerId and turnType
// player needs to automatically have their turn playable
// AND if a decision, decision modal must pop up and not go away until choice socket send is sent
